module.exports = __webpack_public_path__ + "img/QRenglish.dc12f1cf.png";